import { SettingsPermissions } from "@redotech/account-common/permissions";
import { useHandler } from "@redotech/react-util/hook";
import { useTranslation } from "@redotech/redo-i18n";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import type { RejectState } from "@redotech/redo-return-core-common/return-flow-step-valid";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { memo } from "react";
import { useFieldEditable } from "../flow-editor/flow-readonly-context";
import { MessageStepTranslationFields } from "./translations/message-step-translation-fields";

export const RejectDetails = memo(function RejectDetails({
  state,
  setState,
  flowType,
}: StepTypeDetailsProps<RejectState>) {
  const { t } = useTranslation();
  const canEditReturnsSettings = useFieldEditable(
    useHasPermission(SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS),
  );
  const setMessage = useHandler((message: string) =>
    setState((state) => ({ ...state, message })),
  );

  return (
    <MessageStepTranslationFields
      canEdit={canEditReturnsSettings}
      elementId={state.stepUUID}
      flowType={flowType}
      message={state.message}
      placeholder={t("Enter rejection message...")}
      setMessage={setMessage}
    />
  );
});
